import { useTitle } from '@vueuse/core'
import type { Ref} from 'vue'
import { toRef } from 'vue'
import { titleTemplate } from '@/utilities/titleTemplate'

export function useSeoTitle(title: string | Ref<string> | null | undefined) {
  useTitle(toRef(title), { titleTemplate })
}
